import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import Dashboard from './Dashboard';

const HomePage: React.FC = () => {
  const authContext = useContext(AuthContext);
  const { user } = authContext || {};

  if (user?.role === 'developer') {
    return <Navigate to="/financeiro" replace />;
  }

  return <Dashboard />;
};

export default HomePage;
